module.exports = __webpack_public_path__ + "b056afa0323da8a9473bf33a1943508a.svg";